import script from "./GradesPieChart.vue?vue&type=script&setup=true&lang=js"
export * from "./GradesPieChart.vue?vue&type=script&setup=true&lang=js"

import "./GradesPieChart.vue?vue&type=style&index=0&id=5af5b940&scoped=true&lang=css"

import exportComponent from "/home/rlabrovi/Local Sites/vertikal/app/public/wp-content/plugins/climbing-card/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5af5b940"]])

export default __exports__